import { PedFaceMorphSection } from '~/shared';
import nose from '~/assets/icons/nose.svg';
import brows from '~/assets/icons/brows.svg';
import cheekbone from '~/assets/icons/cheekbone.svg';
import eye from '~/assets/icons/eye.svg';
import lips from '~/assets/icons/lips.svg';
import jaw from '~/assets/icons/jaw.svg';
import chin from '~/assets/icons/chin.svg';
import neck from '~/assets/icons/neck.svg';

export const faceMorphIcons = {
	[PedFaceMorphSection.Nose]: nose,
	[PedFaceMorphSection.Brow]: brows,
	[PedFaceMorphSection.Cheekbone]: cheekbone,
	[PedFaceMorphSection.Cheeks]: cheekbone,
	[PedFaceMorphSection.Eyes]: eye,
	[PedFaceMorphSection.Lips]: lips,
	[PedFaceMorphSection.Jaw]: jaw,
	[PedFaceMorphSection.Chin]: chin,
	[PedFaceMorphSection.Neck]: neck,
};

export const faceMorphNames = {
	[PedFaceMorphSection.Nose]: 'Нос',
	[PedFaceMorphSection.Brow]: 'Брови',
	[PedFaceMorphSection.Cheekbone]: 'Скулы',
	[PedFaceMorphSection.Cheeks]: 'Щеки',
	[PedFaceMorphSection.Eyes]: 'Глаза',
	[PedFaceMorphSection.Lips]: 'Губы',
	[PedFaceMorphSection.Jaw]: 'Челюсть',
	[PedFaceMorphSection.Chin]: 'Подбородок',
	[PedFaceMorphSection.Neck]: 'Шея',
};
